import script from "./BasicSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./BasicSettings.vue?vue&type=script&setup=true&lang=js"

import "./BasicSettings.vue?vue&type=style&index=0&id=b93b0d9c&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b93b0d9c"]])

export default __exports__